import styled from "styled-components";

export default styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 320px;
  width: 100%;
  background-color: transparent;
  color: #fff;
  margin: 0 15px;
  font-size: 4em;
`;